/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseServiceUrl } from '../base-service-url';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addHarvestEventsLookup } from '../fn/harvest-events-lookup/add-harvest-events-lookup';
import { AddHarvestEventsLookup$Params } from '../fn/harvest-events-lookup/add-harvest-events-lookup';
import { addMill } from '../fn/harvest-events-lookup/add-mill';
import { AddMill$Params } from '../fn/harvest-events-lookup/add-mill';
import { deleteHarvestEventsLookup } from '../fn/harvest-events-lookup/delete-harvest-events-lookup';
import { DeleteHarvestEventsLookup$Params } from '../fn/harvest-events-lookup/delete-harvest-events-lookup';
import { getFeedMillList } from '../fn/harvest-events-lookup/get-feed-mill-list';
import { GetFeedMillList$Params } from '../fn/harvest-events-lookup/get-feed-mill-list';
import { getHarvestEventsLookup } from '../fn/harvest-events-lookup/get-harvest-events-lookup';
import { GetHarvestEventsLookup$Params } from '../fn/harvest-events-lookup/get-harvest-events-lookup';
import { getHarvestEventsLookupList } from '../fn/harvest-events-lookup/get-harvest-events-lookup-list';
import { GetHarvestEventsLookupList$Params } from '../fn/harvest-events-lookup/get-harvest-events-lookup-list';
import { getHarvestEventsMap } from '../fn/harvest-events-lookup/get-harvest-events-map';
import { GetHarvestEventsMap$Params } from '../fn/harvest-events-lookup/get-harvest-events-map';
import { HarvestEventsLookup } from '../models/harvest-events-lookup';
import { updateHarvestEventsLookup } from '../fn/harvest-events-lookup/update-harvest-events-lookup';
import { UpdateHarvestEventsLookup$Params } from '../fn/harvest-events-lookup/update-harvest-events-lookup';

@Injectable({ providedIn: 'root' })
export class HarvestEventsLookupService extends BaseServiceUrl {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getHarvestEventsLookupList()` */
  static readonly GetHarvestEventsLookupListPath = '/api/harvesteventslookup';

  /**
   * Get Harvest Events Lookup List.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getHarvestEventsLookupList()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHarvestEventsLookupList$Response(params?: GetHarvestEventsLookupList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<HarvestEventsLookup>>> {
    return getHarvestEventsLookupList(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Harvest Events Lookup List.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getHarvestEventsLookupList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHarvestEventsLookupList(params?: GetHarvestEventsLookupList$Params, context?: HttpContext): Observable<Array<HarvestEventsLookup>> {
    return this.getHarvestEventsLookupList$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<HarvestEventsLookup>>): Array<HarvestEventsLookup> => r.body)
    );
  }

  /** Path part for operation `addHarvestEventsLookup()` */
  static readonly AddHarvestEventsLookupPath = '/api/harvesteventslookup';

  /**
   * Add Harvest Events Lookup.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addHarvestEventsLookup()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addHarvestEventsLookup$Response(params: AddHarvestEventsLookup$Params, context?: HttpContext): Observable<StrictHttpResponse<HarvestEventsLookup>> {
    return addHarvestEventsLookup(this.http, this.rootUrl, params, context);
  }

  /**
   * Add Harvest Events Lookup.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addHarvestEventsLookup$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addHarvestEventsLookup(params: AddHarvestEventsLookup$Params, context?: HttpContext): Observable<HarvestEventsLookup> {
    return this.addHarvestEventsLookup$Response(params, context).pipe(
      map((r: StrictHttpResponse<HarvestEventsLookup>): HarvestEventsLookup => r.body)
    );
  }

  /** Path part for operation `getFeedMillList()` */
  static readonly GetFeedMillListPath = '/api/harvesteventslookup/feed/mill';

  /**
   * Get Feed Mill List.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFeedMillList()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeedMillList$Response(params?: GetFeedMillList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<HarvestEventsLookup>>> {
    return getFeedMillList(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Feed Mill List.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFeedMillList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeedMillList(params?: GetFeedMillList$Params, context?: HttpContext): Observable<Array<HarvestEventsLookup>> {
    return this.getFeedMillList$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<HarvestEventsLookup>>): Array<HarvestEventsLookup> => r.body)
    );
  }

  /** Path part for operation `addMill()` */
  static readonly AddMillPath = '/api/harvesteventslookup/harvestevents/addMill';

  /**
   * Add Mill.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addMill()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addMill$Response(params: AddMill$Params, context?: HttpContext): Observable<StrictHttpResponse<HarvestEventsLookup>> {
    return addMill(this.http, this.rootUrl, params, context);
  }

  /**
   * Add Mill.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addMill$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addMill(params: AddMill$Params, context?: HttpContext): Observable<HarvestEventsLookup> {
    return this.addMill$Response(params, context).pipe(
      map((r: StrictHttpResponse<HarvestEventsLookup>): HarvestEventsLookup => r.body)
    );
  }

  /** Path part for operation `getHarvestEventsMap()` */
  static readonly GetHarvestEventsMapPath = '/api/harvesteventslookup/harvesteventsmap';

  /**
   * Get Harvest Events Map.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getHarvestEventsMap()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHarvestEventsMap$Response(params?: GetHarvestEventsMap$Params, context?: HttpContext): Observable<StrictHttpResponse<{
[key: string]: any;
}>> {
    return getHarvestEventsMap(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Harvest Events Map.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getHarvestEventsMap$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHarvestEventsMap(params?: GetHarvestEventsMap$Params, context?: HttpContext): Observable<{
[key: string]: any;
}> {
    return this.getHarvestEventsMap$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
[key: string]: any;
}>): {
[key: string]: any;
} => r.body)
    );
  }

  /** Path part for operation `getHarvestEventsLookup()` */
  static readonly GetHarvestEventsLookupPath = '/api/harvesteventslookup/{harvestEventsLookupId}';

  /**
   * Get Harvest Events Lookup.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getHarvestEventsLookup()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHarvestEventsLookup$Response(params: GetHarvestEventsLookup$Params, context?: HttpContext): Observable<StrictHttpResponse<HarvestEventsLookup>> {
    return getHarvestEventsLookup(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Harvest Events Lookup.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getHarvestEventsLookup$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHarvestEventsLookup(params: GetHarvestEventsLookup$Params, context?: HttpContext): Observable<HarvestEventsLookup> {
    return this.getHarvestEventsLookup$Response(params, context).pipe(
      map((r: StrictHttpResponse<HarvestEventsLookup>): HarvestEventsLookup => r.body)
    );
  }

  /** Path part for operation `updateHarvestEventsLookup()` */
  static readonly UpdateHarvestEventsLookupPath = '/api/harvesteventslookup/{harvestEventsLookupId}';

  /**
   * Update Harvest Events Lookup.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateHarvestEventsLookup()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateHarvestEventsLookup$Response(params: UpdateHarvestEventsLookup$Params, context?: HttpContext): Observable<StrictHttpResponse<HarvestEventsLookup>> {
    return updateHarvestEventsLookup(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Harvest Events Lookup.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateHarvestEventsLookup$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateHarvestEventsLookup(params: UpdateHarvestEventsLookup$Params, context?: HttpContext): Observable<HarvestEventsLookup> {
    return this.updateHarvestEventsLookup$Response(params, context).pipe(
      map((r: StrictHttpResponse<HarvestEventsLookup>): HarvestEventsLookup => r.body)
    );
  }

  /** Path part for operation `deleteHarvestEventsLookup()` */
  static readonly DeleteHarvestEventsLookupPath = '/api/harvesteventslookup/{harvestEventsLookupId}';

  /**
   * Delete Harvest Events Lookup.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteHarvestEventsLookup()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteHarvestEventsLookup$Response(params: DeleteHarvestEventsLookup$Params, context?: HttpContext): Observable<StrictHttpResponse<HarvestEventsLookup>> {
    return deleteHarvestEventsLookup(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Harvest Events Lookup.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteHarvestEventsLookup$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteHarvestEventsLookup(params: DeleteHarvestEventsLookup$Params, context?: HttpContext): Observable<HarvestEventsLookup> {
    return this.deleteHarvestEventsLookup$Response(params, context).pipe(
      map((r: StrictHttpResponse<HarvestEventsLookup>): HarvestEventsLookup => r.body)
    );
  }

}
